export default __webpack_public_path__ + "static/media/request-qp.a0f9af4c.svg";